var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#0072CE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "#0072CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default __webpack_public_path__ + "static/media/radio-checked.8e7eeb2be12cb659114e37e4d20a1117.svg";
export { ForwardRef as ReactComponent };